export default function LegalPage({ title, children }) {
  return (
    <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 py-10 sm:py-14">
      <h1 className="text-3xl sm:text-4xl font-bold text-white mb-2">{title}</h1>
      <p className="text-sm text-gray-400 mb-8">Last updated 20 September 2026</p>
      <div className="space-y-6 text-sm sm:text-base leading-7 text-gray-200">
        {children}
      </div>
    </div>
  );
}
